import React from "react";
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { withRouter } from "react-router";
import "../index.css";
// import Layout from "./Layout/Layout";
import Home from "../pages/Home/Home";
import ContactUs from "../pages/ContactUs/ContactUs";
import AboutUs from "../pages/AboutUs/AboutUs";
import Services from "../pages/Services/Services";


export default function App() {
  return (
    <BrowserRouter>
      <Switch>
        {/* <PublicRoute exact path="/" render={() => <Redirect to="/leadership" />} /> */}
        <PublicRoute exact path="/" component={withRouter(Home)} />
        <PublicRoute exact path="/home" component={withRouter(Home)} />
        <PublicRoute exact path="/services" component={withRouter(Services)} />
        <PublicRoute exact path="/about-us" component={withRouter(AboutUs)} />
        <PublicRoute exact path="/contact-us" component={withRouter(ContactUs)} />
      </Switch>
    </BrowserRouter>
  );

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) =>
        (
          React.createElement(component, props)
        )
        }
      />
    );
  }
}